// extracted by mini-css-extract-plugin
export default {"header":"GheInputsPage_header__IR3Mm","split":"GheInputsPage_split__9tcv8","pane":"GheInputsPage_pane__YrTrE"};